import * as React from 'react';
import {Helmet} from 'react-helmet';
import {generatePath} from 'react-router-dom';

import {convertToArray} from 'nutshell-core/filter';
import {Routing} from 'nutshell-core/routing';
import type {FilterObject} from 'nutshell-core/types';
import {updateUrlParam} from 'nutshell-core/utils/update-url-param';

import {headTitle} from 'shells/document/head-title';

import {readLocalStorage, writeLocalStorage} from '../../../util/localStorage';

import {AuditLog} from './audit-log';

export const AUDIT_LOG_VIEW = 'AUDIT_LOG_VIEW';

export type ContentType = 'bulk-edits' | 'logins' | 'list-actions';

type Props = {
    pageTitle: string;
    location: any;
    match: any;
    history: any;
};

export function AuditLogWrapper(props: Props) {
    React.useEffect(() => {
        const persistedView = readLocalStorage(AUDIT_LOG_VIEW);
        if (persistedView) {
            // split persistedView into two parts, tab is before ? and search is after
            const persistedViewParts = persistedView.split('?');

            const newPath = generatePath(props.match.path, {
                tab: persistedViewParts[0],
            });

            props.history.push({
                pathname: newPath,
                search: persistedViewParts[1],
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    React.useEffect(() => {
        writeLocalStorage(AUDIT_LOG_VIEW, `${props.match.params.tab}${props.location.search}`);
    }, [props.match.params.tab, props.location.search]);

    const setSelectedTab = (tab: ContentType) => {
        const newPath = generatePath(props.match.path, {
            tab,
        });

        props.history.push({
            pathname: newPath,
            search: props.location.search,
        });
    };

    const urlParamString = props.location.search.slice(1); // Remove "?"
    const urlParams = Routing.deparam(urlParamString);
    const activeFilters = convertToArray(urlParams.filter);
    const userFilter = activeFilters.find((filter) => {
        return Object.keys(filter)[0] === 'userId';
    });

    const onParamChange = (newParams: FilterObject) => {
        const newFilter = {
            filter: {
                ...newParams,
            },
        } as const;

        const newSearch = updateUrlParam(urlParams, newFilter);
        props.history.push({
            pathname: props.location.pathname,
            search: newSearch,
        });
    };

    return (
        <>
            <Helmet>
                <title>{headTitle(props.pageTitle)}</title>
            </Helmet>
            <AuditLog
                selectedTab={props.match.params.tab}
                setSelectedTab={setSelectedTab}
                onParamChange={onParamChange}
                filterByUserId={userFilter && userFilter.userId}
            />
        </>
    );
}
